import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CompanyDefaultComponent } from './company-default/company-default.component';
import { RegistrationComponent } from './registration/registration.component';
import { PropertyComponent } from './property/property.component';
import { MyCompanyComponent } from './my-company/my-company.component';
import { PropertiesComponent } from './properties/properties.component';
import { AuthGuard } from '../_helpers/auth.guard';

const routes: Routes = [
  { 
	path: 'company', component: CompanyDefaultComponent, children: [
      { 
        path: '', component: 
        MyCompanyComponent,
        canActivate: [AuthGuard],
        data: { page: 'company', roles: ['admin'] }
      },
      { 
        path: 'properties',
        component: PropertiesComponent,
        canActivate: [AuthGuard],
        data: { page: 'properties', roles: ['admin'] }
      },
      { 
        path: 'property', 
        component: PropertyComponent,
        canActivate: [AuthGuard],
        data: { page: 'property', roles: ['admin'] }
      },
    ]
  },
  { path: 'registration', component: RegistrationComponent },
];


const routes2: Routes = [
  { 
    path: 'company', component: CompanyDefaultComponent, 
    children: [
      { path: '', component: MyCompanyComponent },
      { path: 'properties', component: PropertiesComponent},
    ]
  },
  { path: 'registration', component: RegistrationComponent },
  { path: 'property', component: PropertyComponent },  
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompanyRoutingModule { }
